/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.profile')
    .controller('ProfileEditController', function ($q, $http, $scope, $log, $window, form, User, userQualification, userClub, userAward, hideShowPassword, autocomplete, softdeleteable, showModalMessage, http) {

        var instructorCategories = [];
        var conductorCategories = [];
        var vm = {
            progress: true,
            submitted: false,
            deleted: false,
            formName: '',
            form: {},
            clubEditDisabled: false,
            valid: {},
            blur: {},
            errors: [],
            modal_choose: false,
            achievements: {},
            achievements_errors: {},
            achievements_as_type: {},
            achievements_value: {
                judge_qualification: [],
                coach_qualification: [],
                champion_russia: [],
                world_champion: [],
                european_champion: [],
                russian_cup: [],
                european_cup: [],
                world_cup: []
            },
            club_other_items: [
            {
                id: 0,
                name: 'Отдать голос представителю региональной федерации'
             },
            // {
            //     id: 1,
            //     name: 'Отдать голос президенту ФАР, во время голосования Ваш голос будет учтен в ФАиС Москвы'
            // },
            {
                id: 2,
                name: 'Принимает участие в конференции лично'
            }],
            constructor: function (user, isAdmin) {
                vm.isAdmin = isAdmin;
                vm.form = User.get(user, function () {

                    vm.currentInstructorCategory = vm.form.instructor_category ? vm.form.instructor_category : null;

                    instructorCategories.push(
                        {
                            id: 1,
                            name: 1
                        },
                        {
                            id: 2,
                            name: 2
                        },
                        {
                            id: 3,
                            name: 3
                        }
                    );

                    if (vm.isAdmin || vm.currentInstructorCategory == 4) {
                        instructorCategories.push({
                            id: 4,
                            name: 'ИНП'
                        });
                    }

                    vm.currentConductorCategory = vm.form.conductor_category ? vm.form.conductor_category : null;

                    conductorCategories.push(
                        {
                            id: 1,
                            name: 'до 2А к.сл.'
                        },
                        {
                            id: 2,
                            name: 'до 3Б к.сл.'
                        },
                        {
                            id: 3,
                            name: 'до 4Б к.сл.'
                        },
                        {
                            id: 4,
                            name: 'до 5Б к.сл.'
                        }
                    );
                     
                    vm.clubEditDisabled = vm.form.club && Date.parse(vm.form.member_date_end) > Date.now();
                        vm.form.club_next = vm.form.club ? vm.form.club.id : null;
                    if (angular.isObject(vm.form.country)) {
                        vm.autoCompleteSelect.country = vm.form.country.id;
                    }
              

                    vm.form.enabled = {
                        id: vm.form.enabled
                    };

                    vm.form.gender = {
                        id: vm.form.gender
                    };

                    vm.form.instructor_category = {
                        id: vm.form.instructor_category
                    };

                    vm.form.conductor_category = {
                        id: vm.form.conductor_category
                    };

                    vm.form.awards = {};

                    if (angular.isArray(vm.form.user_awards)) {
                        for (var key in vm.form.user_awards) {
                            var award = vm.form.user_awards[key];
                            var system_name = award.type.system_name;

                            if (vm.form.awards[system_name] == undefined) {
                                vm.form.awards[system_name] = [];
                            }

                            award.type = award.type.id;

                            vm.form.awards[system_name].push(award);
                        }
                    }

                    for ( var key in vm.form.achievements ) {
                        var achievement =  vm.form.achievements[ key ];

                        if ( vm.achievements[ achievement.type.system_name ] == undefined ) {
                            vm.achievements[ achievement.type.system_name ] = [];
                        }

                        if ( angular.isArray( achievement.type.value ) && achievement.type.value.length > 0 ) {
                            achievement.value = {
                                id: achievement.value
                            }
                        }

                        vm.achievements[ achievement.type.system_name ].push({
                            value: achievement.value,
                            year: achievement.year
                        })
                    }

                    $q.all({
                        achievement_types: $http.get(Routing.generate('api_get_user_achievement_types')),
                        award_type: $http.get(Routing.generate('api_get_user_award_type'))
                    }).then(function (values) {
                        for ( var key in values.achievement_types.data ) {
                            vm.achievements_as_type[ key ] = values.achievement_types.data[ key ].id;

                            if ( vm.achievements[ key ] == undefined ) {
                                vm.achievements[ key ] = [{}];
                            }

                            var value = values.achievement_types.data[ key ].value;

                            if ( angular.isArray( value ) && value.length > 0 ) {
                                for ( var i in value ) {
                                    vm.achievements_value[ key ].push( value[ i ] );
                                }
                            }
                        }

                        var userAwardTypes = values.award_type.data;

                        for (var userAwardType in userAwardTypes) {
                            if (vm.form.awards[userAwardTypes[userAwardType].system_name] == undefined) {
                                vm.form.awards[userAwardTypes[userAwardType].system_name] = [{
                                    type: userAwardTypes[userAwardType].id
                                }];
                            }
                        }

                        softdeleteable.setModel(User);

                        vm.progress = false;
                    });
                })
            },
            autoCompleteSelect: {
                country: null,
                region: null,
                city: null
            },
            formUserEdit: form('formUserEdit'),
            hideShowPassword: hideShowPassword,
            submit: function () {
                if ( vm.submitted ) {
                    return false;
                }
                 if(!vm.form.club){
                   return false;
                }
                vm.submitted = true;

                if ( angular.isObject( vm.achievements ) ) {
                    vm.form.achievements = [];
                    vm.achievements_errors = {};

                    var achievements_data = angular.merge({}, vm.achievements);

                    dance:
                    for ( var system_name in achievements_data ) {
                        var achievements = achievements_data[ system_name ];

                        if ( angular.isArray( achievements ) ) {
                            for ( var key in achievements ) {
                                var achievement = achievements[ key ];

                                if ( angular.isObject( achievement.value ) ) {
                                    achievement.value = achievement.value.id;
                                }

                                if( system_name == 'climbing_everest' && achievement.year ) {
                                    achievement.value = true;
                                }

                                if ( achievement.value && achievement.year ) {
                                    vm.form.achievements.push({
                                        user: vm.form.id,
                                        year: achievement.year,
                                        value: achievement.value,
                                        type: vm.achievements_as_type[ system_name ]
                                    });
                                } else if ( achievement.value || achievement.year ) {
                                    if( system_name != 'climbing_everest' ) {
                                        vm.achievements_errors[system_name] = true;

                                        vm.submitted = false;

                                        return false;
                                    }
                                }
                            }
                        }
                    }
                }

                if ( angular.isObject( vm.form.club ) && !vm.form.club_position ) {
                    vm.form.club_position = userClub.position[0];
                }

                if ( angular.isObject( vm.form.alpclub ) && !vm.form.alpclub_position ) {
                    vm.form.alpclub_position = userClub.position[0];
                }
               
     
            
                vm.form.save()
                    .then(function () {
                        $window.location.reload(true);
                    }, function errorCallback(response) {
                        response = http.authenticationListener(response);

                        vm.errors = [];

                        if (angular.isDefined(response.data.errors) ) {
                            for ( var key in response.data.errors ) {
                                vm.errors.push(response.data.errors[key]);
                            }
                        } else {
                            showModalMessage('Ошибка на сервере. Попробуйте позже.');
                        }

                        vm.submitted = false;
                    });
            },
            delete: function() {
                vm.deleted = true;

                softdeleteable.delete(vm.form.id);
            },
            restore: function() {
                vm.deleted = false;

                softdeleteable.restore(vm.form.id);
            }
        };

        vm.formUserEdit
            .addField('enabled', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Статус пользователя',
                    class: 'form__item form__item_select margin_b_40'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
            }, [
                {
                    id: true,
                    name: 'Активный'
                },
                {
                    id: false,
                    name: 'Заблокированный'
                }
            ])
            .addField('member_card', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Номер карты',
                    class: 'form__item width-130'
                }
            })
            .addField('member_date_end', 'dateDropdowns', {
                label: null,
                options: {
                    ngDisabled: function () {
                        if (vm.form.member_card) {
                            return false
                        } else {
                            return true;
                        }
                    }
                }
            })
            .addField('died', 'checkbox', {
                validators: {
                    required: false
                },
                label: 'Поместить в раздел "Памяти"'
            })
            .addField('phone', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Телефон'
                }
            })
            .addField('email', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'E-mail'
                }
            })
            .addField('last_name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Фамилия'
                }
            })
            .addField('first_name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Имя'
                }
            })
            .addField('middle_name', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Отчество'
                }
            })
            .addField('gender', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Пол',
                    class: 'form__item form__item_select margin_b_40'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id'
            }, [
                {
                    id: 'male',
                    name: 'Мужчина'
                },
                {
                    id: 'female',
                    name: 'Женщина'
                }
            ])
            .addField('birthday', 'dateDropdowns', {
                label: null
            })
            .addField('social_vk', 'text', {
                validators: {
                    required: false,
                    urlOnly: ''
                },
                options: {
                    class: 'form__item width-290',
                    placeholder: 'Вконтакте'
                }
            })
            .addField('social_fb', 'text', {
                validators: {
                    required: false,
                    urlOnly: ''
                },
                options: {
                    class: 'form__item width-290',
                    placeholder: 'Facebook'
                }
            })
            .addField('social_in', 'text', {
                validators: {
                    required: false,
                    urlOnly: ''
                },
                options: {
                    class: 'form__item width-290',
                    placeholder: 'Instagram'
                }
            })
            .addField('post_index', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Индекс'
                }
            })
            .addField('address', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Улица'
                }
            })
            .addField('house', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Дом'
                }
            })
            .addField('building', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Кор.'
                }
            })
            .addField('apartment', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Кв.'
                }
            })
            .addField('club_position', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Статус пользователя',
                    class: 'form__item form__item_select width-200',
                    ngDisabled: function () {
                        if (vm.form.club) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userClub.positionList)
            .addField('club_editor', 'checkbox', {
                validators: {
                    required: false
                },
                options: {
                    ngDisabled: function () {
                        if (vm.form.club) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                },
                label: 'Редактор федерации'
            })
            /*
            .addField('club_additional', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Клуб'
                }
            })
            */
            .addField('alpclub', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-400 margin_r_40'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Альпинистский клуб',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: function(name, term, object) {
                        var parent = vm.form.club ? vm.form.club.id : null;

                        var params = {};
                        params.subclub = 'true';
                      // if (parent) {
                     //       params.parent_club = parent;
                     //   }
                        return autocomplete.refreshAutoComplete(name, term, object, params)
                    },
                    onSelect: function (item) {
                        vm.form.alpclub = item;
                    }
                }
            }, autocomplete.get('club'))
            .addField('alpclub_position', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Статус пользователя',
                    class: 'form__item form__item_select width-200',
                    ngDisabled: function () {
                        if (vm.form.alpclub) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userClub.positionList) //clubPosition
            .addField('alpclub_editor', 'checkbox', {
                validators: {
                    required: false
                },
                options: {
                    ngDisabled: function () {
                        if (vm.form.alpclub) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                },
                label: 'Редактор клуба'
            })
            .addField('qualification', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Квалификация',
                    class: 'form__item form__item_select width-350'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userQualification.getList())
            .addField('qualification_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('instructor_category', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Категория инструктора',
                    class: 'form__item form__item_select width-350 margin_r_40'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, instructorCategories)
            .addField('instructor_doc', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Номер удостоверения',
                    class: 'form__item width-170'
                }
            })
            .addField('instructor_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('conductor_category', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Категория инструктора-проводника "Альпинизм и горный туризм"',
                    class: 'form__item form__item_select width-350 margin_r_40'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, conductorCategories)
            .addField('conductor_doc', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Номер удостоверения',
                    class: 'form__item width-170'
                }
            })
            .addField('conductor_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('instructor_job_seeker', 'checkbox', {
                validators: {
                    required: false
                },
                label: 'Ищу работу инструктора'
            })
            .addField('instructor_period_start', 'dateDropdowns', {
                validators: {
                    required: false
                },
                label: null
            })
            .addField('instructor_period_end', 'dateDropdowns', {
                validators: {
                    required: false
                },
                label: null
            })
            .addField('judge_qualification_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('judge_qualification_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Судейская квалификация',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.judge_qualification)
            .addField('coach_qualification_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('coach_qualification_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Тренерская квалификация',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.coach_qualification)
            .addField('champion_russia_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('champion_russia_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Чемпион России',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.champion_russia)
            .addField('world_champion_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('world_champion_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Чемпион мира',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.world_champion)
            .addField('european_champion_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('european_champion_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Чемпион Европы',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.european_champion)
            .addField('russian_cup_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('russian_cup_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Обладатель Кубка России',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.russian_cup)

            .addField('european_cup_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('european_cup_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Обладатель Кубка Европы',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.european_cup)

            .addField('world_cup_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('world_cup_value', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Обладатель Кубка мира',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, vm.achievements_value.world_cup)
            .addField('rescue_in_mountains_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('rescue_in_mountains_value', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Номер удостоверения',
                    class: 'form__item width-170'
                }
            })
            .addField('rescue_squad_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('rescue_squad_value', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Номер удостоверения',
                    class: 'form__item width-170'
                }
            })
            .addField('mountain_guide_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('mountain_guide_value', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Номер удостоверения',
                    class: 'form__item width-170'
                }
            })
            .addField('snow_leopard_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('snow_leopard_value', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Номер удостоверения',
                    class: 'form__item width-170'
                }
            })
                        .addField('snow_leopard_ru_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('snow_leopard_ru_value', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Номер удостоверения',
                    class: 'form__item width-170'
                }
            })
            .addField('climbing_everest_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год восхождения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('user_award_golden_ice_axe_ru_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('user_award_golden_ice_axe_ru_status', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Статус',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userAward.status)
            .addField('user_award_golden_ice_axe_ru_type', 'hidden', {})
            .addField('user_award_steel_angel_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('user_award_golden_ice_axe_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('user_award_golden_ice_axe_status', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Статус',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userAward.status)
            .addField('user_award_golden_ice_axe_type', 'hidden', {})
            .addField('user_award_steel_angel_year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год присвоения',
                    class: 'form__item width-170 margin_r_20',
                    maxlength: 4
                }
            })
            .addField('user_award_steel_angel_status', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Статус',
                    class: 'form__item form__item_select width-170'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userAward.status)
            .addField('user_award_steel_angel_type', 'hidden', {})
            .addField('qualification_ice_climbing', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Ледолазание'
                }
            })
            .addField('qualification_rock_climbing', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Скалолазание'
                }
            })
            .addField('qualification_ski_mountaineering', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Ски-альпинизм'
                }
            })
            .addField('qualification_skyrunning', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Скайраннинг'
                }
            })
            .addField('qualification_mountain_tourism', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Горный туризм'
                }
            })
            .addField('qualification_skiing', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Горные лыжи'
                }
            })
            .addField('avatar', 'imageUpload', {
                validators: {
                    required: false
                },
                label: 'Загрузить изображение',
                uploader: {
                    url: Routing.generate('api_upload_post_avatar', {thumb: 'avatar_relative'}),
                    autoUpload: true,
                    removeAfterUpload: true,
                    onSuccessItem: function (item, response) {
                        vm.form.avatar = response;
                    }
                }
            })
            .addField('country', 'uiSelect', {
                validators: {
                    required: true
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-350'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Страна',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Country", "country")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        if (item) {
                            vm.autoCompleteSelect.country = item.id;
                            vm.autoCompleteSelect.region = null;
                            vm.autoCompleteSelect.city = null;
                            vm.form.country = item;

                            vm.formUserEdit.$fields.region.items = [];
                            vm.formUserEdit.$fields.city.items = [];
                        }
                    }
                },
                fieldData: {
                    name: 'country'
                }
            }, autocomplete.get('country'))
            .addField('region', 'uiTypeahead', {
                validators: {
                    required: true
                },
                label: null,
                options: {
                    class: 'form__item',
                    placeholder: 'Регион',
                    tabindex: 10,
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'Region')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function (name, term) {
                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('city', 'uiTypeahead', {
                validators: {
                    required: false
                },
                label: null,
                options: {
                    class: 'form__item',
                    placeholder: 'Населенный пункт',
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'KladrCity')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function (name, term) {
                        if (angular.isObject(vm.form.region)) {
                            vm.autoCompleteSelect.region = vm.form.region.id;
                        } else {
                            vm.autoCompleteSelect.region = null;
                        }

                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('club', 'uiSelect', {
                validators: {
                    required: true
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-400 margin_r_40'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Федерация альпинизма',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: function(name, term, object) {
                        return autocomplete.refreshAutoComplete(name, term, object, {'subclub':'false'})
                    },
                    onSelect: function (item) {
                        vm.form.club = item;
                    },
                    onClear: function() {
                        return false;
                    }
                }
            }, autocomplete.get('club'))
            .addField('club_other', 'radioCollection', {
                radio: {
                    label: 'name'
                }
            }, vm.club_other_items);

        return vm;
    });
